module.exports = __webpack_public_path__ + "static/img/ma-icon.01ea6b30.gif";